<template>
  <div class="section" id="cont">
    <!--  Header  -->
    <section id="views" class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{ this.empresa.nombre }}</h1>
          <h2 class="subtitle">Diagnóstico de Cultura Organizacional</h2>
        </div>
      </div>
    </section>
    <!--  Data  -->
    <div class="columns fecha">
      <div class="column">
        <span>Fecha de diagnóstico</span>
        <h4 class="has-text-dark">{{ dateProcess(infoProcess.date) }}</h4>
      </div>
      <div class="column is-flex" style='justify-content: right !important;'>
        <div class='control' v-if='!this.$route.params.id'>
          <div class="tags has-addons">
            <span class="tag is-grey-light" style='cursor: pointer' v-tooltip='"Clic para copiar link"' v-on:click='copyLink()'>Compartir Tablero</span>
            <span class="tag is-blue"><i class='material-icons is-size-5'>share</i></span>
          </div>
        </div>
      </div>
    </div>

    <!-- SubHeader - Cards Info  -->
    <section style="margin-top: 30px">
      <div class="container columns has-text-centered">
        <div class="column is-parent is-vertical">
          <div class="box">
            <h1 class="is-size-5 has-text-weight-bold">Participación</h1>
            <span class="is-size-3 has-text-dark">{{ infoProcess.participation }}%</span>
          </div>
        </div>
        <div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 sub has-text-weight-bold">Encuestados</h1>
            <span class="is-size-4">{{ infoProcess.totalParti }}</span>
          </div>
        </div>
        <!--<div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 sub has-text-weight-bold">Eliminados</h1>
            <span class="is-size-4">{{ infoProcess.inconsistencies }}</span>
          </div>
        </div>-->
      </div>
    </section>

    <!--  Section Views  -->
    <div id="views">
      <transition name="fade">
        <!--   ResultadosGeneral   -->
        <section style="margin-top: 40px">
          <ResulParte1 :proceso="this.proceso" @filter="this.filter" :summaryTotal="this.summary"></ResulParte1>
        </section>
      </transition>

    </div>
  </div>
</template>

<script>
import apiServices from "../../services/yungol-services";
import {mapState} from "vuex";
import ResulParte1 from "./ResulParte1.vue";

export default {
  data(){
      return {
        summary: {},
        filters: {},
        selected: {
          grupo: "",
          subgrupos: [],
          filters: {},
        },
        infoProcess: {}
      }
    },
  props: {
    proceso: {
      type: Object,
    },
  },
  methods: {
    async findsummary() {
      try {
        const query = {
          filters: this.selected.filters,
          proceso: this.proceso._id,
        };
        let result = {}
        if (this.$route.params.id){
          result = await apiServices.post(`/traecalculoculturaPb`, query);
        }else {
          result = await apiServices.post(`/traecalculocultura`, query);
        }

        if (result.data) {
          let filters = {list: []};
          /* Se guardan los grupos y subgrupos de cada grupo */
          for (let index in result.data.grupos) {
            const dato = result.data.grupos[index];
            filters.list.push(dato.nombre);
            filters[dato.nombre] =
                result.data.calculos[dato.nombre].subgrupos;
          }
          this.filtersselected = JSON.parse(
              JSON.stringify(this.selected.filters)
          );

          this.summary = result.data.calculos;

          let empty = true

          for(const index in this.summary.total ){
            let varD = this.summary.total[index]
            if(varD.p > 0){
              empty = false
            }
          }

          this.summary.empty = empty
          this.infoProcess = result.data.infoProcess
        }
      } catch (err) {
        console.log(err);
      }
    },
    filter(filters){
      this.selected.filters = filters
      this.findsummary()
    },
    dateProcess(d) {
      let date = new Date(d)
      let options = {year: 'numeric', month: 'long', day: 'numeric'}
      date = date.toLocaleDateString(undefined, options)
      return date
    },
    async copyLink(filter = null) {
      let textArea = document.createElement("textarea");

      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em';
      textArea.style.height = '2em';

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = 'transparent';

      let data = {};

      filter = filter ? JSON.stringify(filter) : JSON.stringify(this.selected.filters)

      const encodeFilter = btoa(filter) // Para descifrarlo es con atob()

      data.report = this.proceso._id
      console.log(this.proceso._id)
      data.filter = btoa(encodeFilter) // Se vuelve a cifrar

      textArea.value = window.location.host + "/cultura/share/" + data.report + "/" + data.filter;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand('copy')
        let msg = successful ? '¡Copiado al portapapeles!' : 'Error al copiar'
        let type = successful ? 'is-link' : 'is-danger'

        await this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });

      } catch (err) {
        await this.$store.dispatch("notify", {
          message: 'Error al copiar',
          type: 'is-danger',
        });
      }
      document.body.removeChild(textArea);
    },
  },
  computed: {
    ...mapState(["empresa", "isOculto"]),
  },
  beforeMount() {
    if(this.isOculto){
      this.$store.commit("ocultarSide");
    }
  },
  created(){
    this.findsummary()
  },
  components: {
    ResulParte1
  }
}
</script>

<style scoped lang="scss">
.fecha {
  margin-top: 10px;
  margin-left: 2px;
}

.box-sub {
  height: 118px !important;
}

.fecha table {
  justify-content: end;
}

.is-blue{
  background-color: #a8c2ef !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Resultadoscultura.vue